class RunCamProductEnhancements {
  constructor(root) {
    this.root = root;
    this.controls = Array.from(this.root.querySelectorAll('slideshow-controls[thumbnails]'));
    this.resizeObserver = new ResizeObserver(() => this.updateThumbnailRail());
    this.updateThumbnailRail();

    for (const controls of this.controls) {
      const rail = controls.querySelector('.slideshow-controls__thumbnails-container');
      if (!rail) continue;
      this.resizeObserver.observe(rail);
      const thumbnails = rail.querySelector('.slideshow-controls__thumbnails');
      if (thumbnails) this.resizeObserver.observe(thumbnails);
    }
  }

  updateThumbnailRail() {
    for (const controls of this.controls) {
      const rail = controls.querySelector('.slideshow-controls__thumbnails-container');
      if (!rail) continue;
      controls.dataset.railOverflow = String(rail.scrollWidth > rail.clientWidth + 1);
    }
  }
}

const enhancements = new WeakMap();

function initializeRunCamProducts(root = document) {
  for (const gallery of root.querySelectorAll('[data-runcam-thumbnail-rail]')) {
    if (!enhancements.has(gallery)) enhancements.set(gallery, new RunCamProductEnhancements(gallery));
  }
}

initializeRunCamProducts();
document.addEventListener('shopify:section:load', (event) => initializeRunCamProducts(event.target));

class RunCamAccessoriesCarousel extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-runcam-accessories-rail]');
    this.controls = this.querySelector('[data-runcam-accessories-controls]');
    this.previousButton = this.querySelector('[data-runcam-accessories-previous]');
    this.nextButton = this.querySelector('[data-runcam-accessories-next]');
    if (!this.rail || !this.controls || !this.previousButton || !this.nextButton) return;

    this.update = this.update.bind(this);
    this.showPrevious = () => this.scroll(-1);
    this.showNext = () => this.scroll(1);
    this.rail.addEventListener('scroll', this.update, { passive: true });
    this.previousButton.addEventListener('click', this.showPrevious);
    this.nextButton.addEventListener('click', this.showNext);
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.rail);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.rail?.removeEventListener('scroll', this.update);
    this.previousButton?.removeEventListener('click', this.showPrevious);
    this.nextButton?.removeEventListener('click', this.showNext);
  }

  scroll(direction) {
    this.rail.scrollBy({ left: direction * this.rail.clientWidth, behavior: 'smooth' });
  }

  update() {
    const maximum = this.rail.scrollWidth - this.rail.clientWidth;
    const hasOverflow = maximum > 1;
    this.controls.hidden = !hasOverflow;
    this.previousButton.disabled = !hasOverflow || this.rail.scrollLeft <= 1;
    this.nextButton.disabled = !hasOverflow || this.rail.scrollLeft >= maximum - 1;
  }
}

if (!customElements.get('runcam-accessories-carousel')) {
  customElements.define('runcam-accessories-carousel', RunCamAccessoriesCarousel);
}
